export enum OrdenEstadoDePago {
  EnDeuda,
  Pagada,
}

export const OrdenEstadoDePagoLabels: {
  [key in OrdenEstadoDePago]: string;
} = {
  [OrdenEstadoDePago.EnDeuda]: 'En Deuda',
  [OrdenEstadoDePago.Pagada]: 'Pagada',
};

export const getOrdenEstadoDePago = () => {
  return Object.values(OrdenEstadoDePago)
    .filter((value) => typeof value === 'number')
    .map((id) => ({
      id,
      text: OrdenEstadoDePagoLabels[id as OrdenEstadoDePago],
    }));
};
export const colorMapping: { [key in OrdenEstadoDePago]: string } = {
  [OrdenEstadoDePago.EnDeuda]: 'orange',
  [OrdenEstadoDePago.Pagada]: '#22C55E',
};
